// import CustomizableAvatar from "../common/CustomizableAvatar";
// import Smartlend from "../../assets/SMARTLEND.png";
// import CustomButton from "../common/CustomButton";
// import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const VerifyEmail = ({ email }) => {
//   const navigate = useNavigate();

//   //   Form submission
//   const onSubmit = async (values) => {
//     try {
//       // Make API request to verify email
//       const response = await axios.post(
//         "https://smartapp-lendbackend.onrender.com/api/admin/verify-email",
//         values
//       );

//       // Handle the API response
//       console.log("API response", response.data);

//       // Navigate to "/verificationMsg" route on successful submission
//       navigate("/verificationMsg");
//     } catch (error) {
//       // Handle any errors that occurred during the API request
//       console.error("API error", error);
//       alert(error.response.data);
//     }
//   };

//   return (
//     <div className=" container mx-auto my-10  text-center  p-8 ">
//       <CustomizableAvatar
//         src={Smartlend}
//         customClass={"flex justify-center py-4"}
//       />
//       <p className=" text-4xl font-medium p-7">Verify email address</p>
//       <p className="text-sm font-normal px-8 pb-2 text-center">
//         We just sent a verification mail to{" "}
//         <span className="text-amber-300">{email}</span>. Click on the
//         link in the mail to complete verification
//       </p>
//       <p className="text-amber-700 text-base p-3 pb-8">
//         Please note that the link will expire in 4 hours
//       </p>
//       <CustomButton
//         className={
//           "bg-indigo-500 text-slate-50 border rounded my-3 cursor-pointer hover:bg-indigo-600"
//         }
//         onClick={async () => {
//           // Call the onSubmit function when the button is clicked
//           await onSubmit({ email }); // Pass the email value for the API request
//         }}
//       >
//         <Link to={"/email_verification_message"} className="px-14">
//           Open email
//         </Link>
//       </CustomButton>
//       <p className="py-5">
//         {" "}
//         Didn't get the email?{" "}
//         <Link to={"#Request"} className="text-indigo-500">
//           Request again
//         </Link>
//       </p>
//     </div>
//   );
// };

// export default VerifyEmail;

// YOUR CODE UNTOUCHED
import CustomizableAvatar from "../common/CustomizableAvatar";
import Smartlend from "../../assets/SMARTLEND.png";
import CustomButton from "../common/CustomButton";
import { Link } from "react-router-dom";

const VerifyEmail = () => {
  return (
    <div className=" container mx-auto my-10  text-center  p-8 ">
      <CustomizableAvatar
        src={Smartlend}
        customClass={"flex justify-center py-4"}
      />
      <p className=" text-4xl font-medium p-7">Verify email address</p>
      <p className="text-sm font-normal px-8 pb-2 text-center">
        We just sent a verification mail to{" "}
        <span className="text-amber-300">idowu@stutern.com</span>. Click on the
        link in the mail to complete verification
      </p>
      <p className="text-amber-700 text-base p-3 pb-8">
        Please note that the link will expire in 4 hours
      </p>
      <CustomButton
        className={
          "bg-indigo-500 text-slate-50 border rounded my-3 cursor-pointer hover:bg-indigo-600"
        }
      >
        <Link to={"/email_verification_message"} className="px-14">
          Open email
        </Link>
      </CustomButton>
      <p className="py-5">
        {" "}
        Didn't get the email?{" "}
        <Link to={"#Request"} className="text-indigo-500">
          Request again
        </Link>
      </p>
    </div>
  );
};

export default VerifyEmail;
